<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">支付记录</li>
      </ol>
    </div>

    <div class="content-query content-border">
      <el-form :inline="true" :model="query">
        <el-form-item label="订单号：">
          <el-input clearable type="text" v-model="query.code"></el-input>
        </el-form-item>
        <el-form-item label="用户：">
          <el-input clearable type="text" v-model="query.nickname"></el-input>
        </el-form-item>
        <el-form-item label="资产类型：">
          <el-select v-model="query.assetType" clearable>
            <el-option v-for="(item, index) in assetType" :key="index" :label="item.label" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付渠道：">
          <el-select v-model="query.payChannel" clearable>
            <el-option v-for="(item, index) in payChannel" :key="index" :label="item.label" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="title">
      <span>商城订单支付记录</span>
    </div>
    <el-table border :data="orderPays" highlight-current-row>
      <el-table-column label="序号" align="center" type="index"/>
      <el-table-column label="订单号" align="center" prop="code"/>
      <el-table-column label="用户信息" align="center">
        <template slot-scope="scope">
          <user-info :icon-path="scope.row.iconPath" :nickname="scope.row.nickname"/>
        </template>
      </el-table-column>
      <el-table-column label="支付金额" align="center" prop="payMoney">
        <template slot-scope="scope">
          ￥{{ scope.row.payMoney }}
        </template>
      </el-table-column>
      <el-table-column label="支付渠道" align="center" prop="payChannelLabel"/>
      <el-table-column label="资产类型" align="center" prop="assetTypeLabel"/>
      <el-table-column label="支付时间" align="center" prop="payTime"/>
    </el-table>
    <vue-pager v-bind:datafile="fillData" url="orderPay/pageOrderPayByManager" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderPays: [],
      query: {},
      assetType: [],
      payChannel: [],
    }
  },
  created() {
    var _this = this;
    _this.assetType = _this.$common.enum_config('EAssetType');
    _this.assetType.splice(0, 0, {name: null, label: '全部'});

    _this.payChannel = _this.$common.enum_config('EPayChannel');
    _this.payChannel.splice(0, 0, {name: null, label: '全部'});
  },
  methods: {
    fillData(_response) {
      var _this = this;
      _this.orderPays = _response.items;
    },
    submitQuery(_num) {
      var _this = this;
      _this.orderPays = [];
      _this.$refs.pager.gotoPage(_num);
    }
  }
}
</script>
<style scoped>
.table td {
  text-align: center;
}
</style>
